module.exports = __webpack_public_path__ + "static/media/logo_black.eeb5d7fe.webp";